module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/cadastro-servico/cadastro-servico.component.css
// module id = ./src/app/artefato/cadastro-servico/cadastro-servico.component.css
// module chunks = main